import { Colors } from '@sigma-frontend-libs/commons'

import render from './render'
import { buttonModes, components, placements, sizes } from '../../utils/constants'
import { eventHandlers } from '../../utils/mixins'
import { form } from '../../utils/mixins/props/form'

const className = 'button'

export default {
  name: 'Btn',

  mixins: [ form, eventHandlers ],

  props: {
    label: {
      type: [ String, Number, Boolean ],
      default: undefined
    },

    icon: String,
    iconSVG: String,
    iconColor: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    prefix: String,
    suffix: String,
    tooltip: String,

    loading: Boolean,
    disabled: Boolean,

    fullWidth: Boolean,

    name: String,
    type: {
      type: String,
      default: 'button'
    },

    color: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },
    size: {
      type: String,
      default: sizes.medium,
      validator: value => {
        return Object.values(sizes).includes(value)
      }
    },
    mode: {
      type: String,
      default: buttonModes.filled,
      validator: value => {
        return Object.values(buttonModes).includes(value)
      }
    }
  },

  computed: {
    $_attrs() {
      return {
        name: this.name,
        type: this.type,
        form: this.form,
        formaction: this.formaction,
        formenctype: this.formenctype,
        formmethod: this.formmethod,
        formnovalidate: this.formnovalidate,
        formtarget: this.formtarget,
        disabled: this.disabled
      }
    },

    $_class() {
      return {
        [`${className}`]: true,

        [`${className}--icon`]: this.hasIcon || !!this.$slots.icon,
        [`${className}--label`]: !!this.$_label,

        [`${className}--prefix`]: !!this.prefix || !!this.icon,
        [`${className}--suffix`]: !!this.suffix,

        [`${className}--${this.size}`]: true,
        [`${className}--${this.mode}`]: true,

        [`${className}--${this.color}`]: !!this.color,

        [`${className}--loading`]: this.loading,
        [`${className}--disabled`]: this.disabled,

        [`${className}--full-width`]: this.fullWidth
      }
    },

    $_directives() {
      const result = []
      if (this.tooltip) {
        result.push({
          name: components.tooltip,
          options: {
            value: this.tooltip,
            placement: placements.top
          }
        })
      }

      return result
    },

    hasIcon() {
      return !!this.icon || !!this.iconSVG || !!this.$slots.icon || !!this.prefix
    },

    $_icon() {
      return this.iconSVG || this.icon || this.$slots.icon || this.prefix
    },
    $_iconSize() {
      switch (this.mode) {
        case buttonModes['flat-icon']: {
          switch (this.size) {
            case sizes.tiny: return 18
            case sizes.small: return 20
            case sizes.medium: return 26
          }
        }
        default: {
          switch (this.size) {
            case sizes.tiny: return 12
            case sizes.small: return 14
            case sizes.medium: return 20
          }
        }
      }
    },
    $_iconColor() {
      let result = this.color
      if (this.mode === buttonModes.filled) {
        if (this.color === Colors.white) {
          result = Colors.black
        } else {
          result = Colors.white
        }
      }
      if (this.iconColor) {
        result = this.iconColor
      }

      return result
    },

    $_label() {
      switch (typeof this.label) {
        case 'number':
        case 'boolean': return this.label.toString()
        case 'string': return this.label
      }
    },

    preloaderColor() {
      let result = this.color
      if (this.mode === buttonModes.filled) {
        if (this.color === Colors.white) {
          result = Colors.black
        } else {
          result = Colors.white
        }
      }

      return result
    },
    preloaderCount() {
      let result = 3
      if (this.icon || !this.$_label || this.$_label && this.$_label.length < 3) {
        result = 2
      }

      return result
    }
  },

  render
}
